import "@hotwired/turbo-rails"
import "~/styles/application.css"

import * as ActiveStorage from "@rails/activestorage"
import "trix"
import "@rails/actiontext"

import { Application } from "@hotwired/stimulus"
import CarouselController from "~/controllers/carousel_controller"
import ExpandableController from "~/controllers/expandable_controller"
import FlashController from "~/controllers/flash_controller"
import NavController from "~/controllers/nav_controller"
import ModalController from "~/controllers/modal_controller"
import FilterFormController from "~/controllers/filter_form_controller"
import SouvenirsController from "~/controllers/souvenirs_controller"
import ImagePreviewController from "~/controllers/image_preview_controller"
import PasswordToggleController from "~/controllers/password_toggle_controller"
import GalleryController from "~/controllers/gallery_controller"

ActiveStorage.start()

const application = Application.start()
application.register("carousel", CarouselController)
application.register("expandable", ExpandableController)
application.register("flash", FlashController)
application.register("nav", NavController)
application.register("modal", ModalController)
application.register("filter-form", FilterFormController)
application.register("souvenirs", SouvenirsController)
application.register("image-preview", ImagePreviewController)
application.register("password-toggle", PasswordToggleController)
application.register("gallery", GalleryController)
